module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// /Users/gtirby/develop/~/babel-runtime/regenerator/index.js
// module id = 278
// module chunks = 0